<app-header></app-header>
<div style='height: 100px; background: #EEEEEE 0% 0% no-repeat padding-box;' class='border-4 border-bottom'>
  <div class="row">
    <div class="col-md-12">
      <h2 class="text-center pt-4">
        <span class="font-color-navy welcome-text pt-4">My Tasks</span>
      </h2>
    </div>
  </div>
</div>
<br />
<div class="container-fluid font-color-navy container-shadow">
  <div id="detailledInformationTabs" class="detailledInformationTabs">
    <ul style="padding: 0px 0px;">
      <li [ngClass]="currentTab == '/pendingtasks' ? 'col-md-4 ui-tabs-active' : 'col-md-4 ui-tabs-inactive'"><a (click)="onNavigate('pendingtasks')">Pending<span *ngIf="pendingTasksCount>-1">({{pendingTasksCount}})</span></a></li>
      <li  [ngClass]="currentTab == '/opentasks' ? 'col-md-4 ui-tabs-active' : 'col-md-4 ui-tabs-inactive'"><a (click)="onNavigate('opentasks')">Done</a></li>
      <li  [ngClass]="currentTab == '/alltasks' ? 'col-md-4 ui-tabs-active' : 'col-md-4 ui-tabs-inactive'"><a (click)="onNavigate('alltasks')">All</a></li>
    </ul>
    <router-outlet></router-outlet>
  </div>
</div>
